var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle-bar circle-bar__progress-bar",style:('background-image: ' + _vm.backgroundImage)},[_c('div',{staticClass:"circle-bar__overlay",style:(_vm.circleBarStyle)},[_vm._v("\n    "+_vm._s(_vm.text ? _vm.text : _vm.value + '%')+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }